import {NotificationService} from "../../services/NotificationService";
import { GrantTypes } from "../../libs/GrantTypes";
import { PrintClient } from "../../entities/PrintClient";
import { PrintClientService } from "../../services/PrintClientService";
import { CompanyService } from "../../services/CompanyService";
import { Company } from "../../entities/Company";

export class EditPrintClientCtrl {
    $scope: any;
    originalUsername: string;
    originalPassword: string;
    entity: PrintClient;
    selectedAvailableCompanies: Company[];
    selectedAssignedCompanies: Company[];
    availableCompanies: Company[];
    assignedCompanies: Company[];
    modalInstance:angular.ui.bootstrap.IModalServiceInstance;
    public static $inject = ['$scope', '$uibModalInstance', 'PrintClientService', 'NotificationService', 'CompanyService', 'printClient','companyId'];
    constructor($scope: any, $modalInstance: angular.ui.bootstrap.IModalServiceInstance,
            public printClientService: PrintClientService,
        public notifyService: NotificationService,
        public companyService: CompanyService,
            printClient: PrintClient) {
        this.$scope = $scope;
        this.entity = printClient;
        this.originalUsername = printClient.username;
        this.originalPassword = printClient.password;
        this.modalInstance = $modalInstance;
        $scope.vm = this;
        if(printClient.id == null){
            this.printClientService.generateSecret().then((secret) => {
                printClient.password = secret;
            });
        }
        this.companyService.getAll().then((companies) => {
            this.assignedCompanies = [];
            this.availableCompanies = [];
            var tempAssignedCompanies: Company[] = [];
            var tempAvailableCompanies: Company[] = [];
            for (var i = 0; i < companies.length; i++) {
                var tempCompany = companies[i];
                var foundAt = -1;
                for (var j = 0; j < this.entity.companies.length; j++) {
                    var alreadyAssigned = this.entity.companies[j];
                    if (tempCompany.id === alreadyAssigned.id) {
                        foundAt = j;
                        break;
                    }
                }
                if (foundAt != -1) {
                    //this company is already assigned to the entity
                    tempAssignedCompanies.push(tempCompany);
                }
                else {
                    tempAvailableCompanies.push(tempCompany);
                }
            }
            this.assignedCompanies = tempAssignedCompanies;
            this.availableCompanies = tempAvailableCompanies;
        });
    }
    addCompanies() {
        var toCopy = this.selectedAvailableCompanies.slice();

        for (var i = this.availableCompanies.length - 1; i >= 0; i--) {
            var curr = this.availableCompanies[i];
            for (var j = 0; j < toCopy.length; j++) {
                if (curr.id === toCopy[j].id) {
                    this.availableCompanies.splice(i, 1);                    
                }
            }
        }
        for (var i = 0; i < toCopy.length; i++) {
            this.assignedCompanies.push(toCopy[i]);
        }
    }
    removeCompanies() {
        var toCopy = this.selectedAssignedCompanies.slice();

        for (var i = this.assignedCompanies.length - 1; i >= 0; i--) {
            var curr = this.assignedCompanies[i];
            for (var j = 0; j < toCopy.length; j++) {
                if (curr.id === toCopy[j].id) {
                    this.assignedCompanies.splice(i, 1);
                }
            }
        }
        for (var i = 0; i < toCopy.length; i++) {
            this.availableCompanies.push(toCopy[i]);
        }
    }
    newSecret() {
        this.printClientService.generateSecret().then((secret) => {
            this.entity.password = secret;
        })
    }
    ok() {
        if (!this.entity.username.match(/^[0-9a-z]+$/i)) {
            this.notifyService.notifyError(("Username must be alpha numeric with no spaces."));
            return;
        }        
        if (this.entity.username == null || this.entity.username.length == 0) {
            this.notifyService.notifyError(("Username is required"));
            return;
        }
        if (this.entity.name == null || this.entity.name.length == 0) {
            this.notifyService.notifyError(("Name is required"));
            return;
        }
        if (this.entity.password == null || this.entity.password.length == 0) {
            this.notifyService.notifyError(("Password is required"));
            return;
        }
        if (this.assignedCompanies.length == 0) {
            this.notifyService.notifyError(("Please assign at least one company"));
            return;
        }
        this.entity.companies = this.assignedCompanies;
        this.modalInstance.close(true);
    }

    cancel() {
        this.modalInstance.dismiss('cancel');
    }
}
